<!--  -->
<template>
  <div class="gameCode-container">
    <div class="game-list">
      <div class="game-add" @click="addChange('新建定制化产品')">
        <PlusOutlined />
        <span style="padding-top: 3px;
    padding-left: 2px;">新增产品</span>
      </div>
      <div class="game-item" v-for="(item,index) in productsList" :key="index">
        <a-card hoverable>
          <template #cover>
            <div
              class="cover-img"
              :style="`background-image: url(${item.coverImg})`"
              @click="router.push({name:'listItem',query:{id: item.id}})"
            ></div>
          </template>
          <a-card-meta :title="item.name">
            <template #description>
              <div class="desc-box">
                <a-tag color="purple" class="tag-des">
                  <span>创建时间:</span>
                  {{item.createdAt}}
                </a-tag>
                <a-tag color="orange" class="tag-des">
                  <span>专题Code:</span>
                  {{item.productCode}}
                </a-tag>
              </div>
            </template>
          </a-card-meta>
          <template class="ant-card-actions" #actions>
            <div @click="editChange('编辑定制化产品',item)">
              <edit-outlined key="edit" />
              <span style="padding-left: 5px;">编辑</span>
            </div>
            <div @click="router.push({name:'listItem',query:{id: item.id}})">
              <setting-outlined key="setting" />
              <span style="padding-left: 5px;">管理</span>
            </div>
          </template>
          <div class="ribbon-box">
            <span
              class="box-span"
              :style="item.type === 'event'  || item.type === 'official' ? 'top: 20px' : item.type === 'pre' ? 'top: 17px;right:16px' : ''"
            >{{item.typeName}}</span>
          </div>
        </a-card>
      </div>
    </div>
    <a-modal
      v-model:visible="modalVisible"
      :title="modalTitle"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
    >
      <a-form ref="formRef" :model="modalFormState" :rules="rules">
        <a-form-item ref="name" label="定制化页面名称" name="name">
          <a-input v-model:value="modalFormState.name" placeholder="请选择产品名称" />
        </a-form-item>
        <a-form-item label="定制化页面类型" name="type">
          <a-select v-model:value="modalFormState.type" placeholder="请选择产品类型">
            <a-select-option
              :value="item.value"
              v-for="(item,index) in typeList"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  ref,
  onMounted,
  warn,
  watch
} from "vue";

import {
  SettingOutlined,
  EditOutlined,
  EllipsisOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import { getProductsList, productsCreate, productsEdit } from "@/api/index";
import { useStore } from "vuex";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

// 导入的其他文件 例如：import moduleName from 'modulePath';
export default defineComponent({
  components: {
    SettingOutlined,
    EditOutlined,
    EllipsisOutlined,
    PlusOutlined
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      modalVisible: false,
      modalTitle: "",
      modalItem: {},
      modalFormState: {},
      productsList: [],
      typeList: [
        {
          value: "lp",
          name: "LP"
        },
        {
          value: "pre",
          name: "预注册"
        },
        {
          value: "official",
          name: "官网"
        },
        {
          value: "event",
          name: "专题、活动"
        }
      ]
    });
    const rules = {
      name: [
        {
          required: true,
          message: "请输入定制化页面名称",
          trigger: "blur"
        }
      ],
      type: [
        {
          required: true,
          message: "请选择定制化页面类型",
          trigger: "change"
        }
      ]
    };
    // const productResultList = computed(() => {
    //   let result;
    //   state.productsList
    // })
    const formRef = ref(null);
    const addOkChange = async () => {
      await formRef.value.validate();
      try {
        await productsCreate(
          Object.assign({}, state.modalFormState, { gameCode: gameCode.value })
        );
        message.success("创建成功");
      } catch (error) {
        console.log(error.response);
        const { error_code } = error.response.data.exception;
        if (error_code === 400501) {
          message.error("创建失败，名字重复！");
        }
      }
    };
    const editOkChange = async item => {
      await formRef.value.validate();
      try {
        await productsEdit(state.modalItem.id, state.modalFormState);
        message.success("编辑成功");
      } catch (error) {
        console.log(error.response);
        const { error_code } = error.response.data.exception;
        if (error_code === 400501) {
          message.error("编辑失败，名字重复！");
        }
      }
    };
    const handleOk = async () => {
      if (state.modalTitle === "新建定制化产品") {
        await addOkChange();
      }
      if (state.modalTitle === "编辑定制化产品") {
        await editOkChange();
      }
      state.modalVisible = false;
      await formRef.value.resetFields();
      getListChange();
    };

    const addChange = title => {
      state.modalTitle = title;
      state.modalVisible = true;
    };
    const editChange = (title, item) => {
      state.modalTitle = title;
      state.modalVisible = true;
      state.modalItem = item;
      state.modalFormState = { name: item.name, type: item.type };
    };
    const gameCode = computed(() => {
      return store.state.settings.currentGamgeCode;
    });
    const getListChange = async () => {
      const res = await getProductsList({ gameCode: gameCode.value });
      console.log(res, "res1111111");
      res.data.products.forEach(item => {
        item.createdAt = dayjs(item.createdAt * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        switch (item.type) {
          case "lp":
            item.typeName = "LP";
            item.coverImg = require("../../../../../assets/images/lp.jpg");
            break;
          case "pre":
            item.typeName = "预注册";
            item.coverImg = require("../../../../../assets/images/register.jpg");
            break;
          case "official":
            item.typeName = "官网";
            item.coverImg = require("../../../../../assets/images/official.jpg");
            break;
          case "event":
            item.typeName = "专题";
            item.coverImg = require("../../../../../assets/images/topic.jpg");
            break;
        }
      });
      state.productsList = res.data.products;
    };
    watch([gameCode], ([currentCode, pre]) => {
      console.log(currentCode, "currentCode");
      if (currentCode) {
        getListChange();
      }
    });
    watch(
      () => state.modalFormState.name,
      (name, prev) => {
        state.modalFormState.name = name && name.replace(/\s/g, "");
      }
    );
    watch(
      () => state.modalVisible,
      (modalVisible, prev) => {
        if (!modalVisible) {
          state.modalFormState = {};
        }
      }
    );
    onMounted(() => {
      getListChange();
    });
    return {
      ...toRefs(state),
      handleOk,
      addChange,
      editChange,
      rules,
      formRef,
      router
    };
  }
});
</script>
<style lang="less">
@media screen and (max-width: 1930px) and (min-width: 1690px) {
  .game-item {
    .ant-card-cover {
      height: 250px !important;
    }
  }
  .game-add {
    // width: 515px !important;
    height: 404px !important;
  }
}
@media screen and (max-width: 1689px) and (min-width: 1450px) {
  .game-item {
    .ant-card-cover {
      height: 225px !important;
    }
  }
  .game-add {
    // width: 440px !important;
    height: 376px !important;
  }
}
@media screen and (max-width: 1449px) and (min-width: 1300px) {
  .game-item {
    .ant-card-cover {
      height: 210px !important;
    }
  }
  .game-add {
    // width: 360px !important;
    height: 363px !important;
  }
}
.game-item {
  .ant-card-cover {
    height: 345px;
  }
  .ant-card
    .ant-card-body
    .ant-card-meta
    .ant-card-meta-avatar
    .ant-avatar-image {
    width: 60px !important;
    height: 60px !important;
  }
}
.ant-card-meta-title {
  text-align: left;
  max-width: 450px;
}
.ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
</style>